import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "@/analytics/analytics";
import { trackPageViewed } from "@/analytics/analytics";
import { sourceProps } from "@/analytics/source";

const EXCLUDED_ROUTES = ["/subscribe", "/subscribe/success", "/subscribe/cancel"];

const AnalyticsRouteLogger = () => {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    analytics.setContext({ route: path });
    if (!EXCLUDED_ROUTES.includes(location.pathname)) {
      trackPageViewed({ route: location.pathname, ...sourceProps(location.search) });
    }
  }, [location]);

  return null;
};

export default AnalyticsRouteLogger;
